import { useCallback } from "react";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import useSelectedDataLake from "data-lake/hooks/useSelectedDataLake";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
const useReexecuteSearch = () => {
  const sendTelemetry = useSendTelemetry("log-view-widget");
  const { selectedDataLake } = useSelectedDataLake();
  return useCallback(
    (e) => {
      if (
        // eslint-disable-next-line no-alert
        !window.confirm("Re-executing the search job may take some time. Do you want to proceed?")
      ) {
        e.preventDefault();
      } else {
        sendTelemetry(TELEMETRY_EVENT_TYPE.DATALAKE.PREVIEW[selectedDataLake.type].WIDGET_REEXECUTE_SEARCH, {
          app_pathname: "/data-storage/preview",
          event_details: {
            data_lake_storage_type: selectedDataLake.storageType
          }
        });
      }
    },
    [selectedDataLake.storageType, selectedDataLake.type, sendTelemetry]
  );
};
export default useReexecuteSearch;
